import React, { useState, useEffect, useRef, useContext } from 'react'
import styles from './AgregarHijo.module.css'
//Services
import * as FamiliarRepository from "../../services/repositories/familiar-repository";
//Utiles
import * as Funciones from '../../utils/funciones'
import * as Constantes from '../../utils/constantes'
import CampoFecha from '../CampoFecha/CampoFecha'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from "../../store/actions/generalActions";

const AgregarHijo = ({ mostrarModal, setModal, state, setState, pFamiliar, recargarLista }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const [documentos, setDocumentos] = useState([])
  const [ocupaciones, setOcupaciones] = useState([])
  const [stateOcupaciones, setStateOcupaciones] = useState([])
  const ocupacionesRef = useRef()

  useEffect(() => {
    const cargarCombos = () => {
      setOcupaciones(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 9))
      setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
    }

    cargarCombos()
  }, [])

  const onChangeInputDate = (valor) => {
    handleChangeFecha(valor, 'fechaNacimiento')
  }

  const handleChangeFecha = (e, campo) => {
    let valor = e
    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          [campo]: Funciones.transformarDatePickerToFecha(valor)
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          [campo]: true
        }
      }
    })
  }

  const handleChangeTipDocumento = (e, campo) => {
    let codigo = e.target.value
    let descripcion = e.target[e.target.selectedIndex].text
    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          [campo]: {
            codigo: parseInt(codigo),
            descripcion: descripcion
          },
          numeroDocumento: ''
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          [campo]: true
        }
      }
    })
  }

  const handleChangeOcupacion = (e) => {
    if (e.target.value.length > 2) {
      let ocupacionesFilter = ocupaciones.filter(ocupa => ocupa.valor.toUpperCase().indexOf(e.target.value.toUpperCase()) >= 0)
      setStateOcupaciones({
        ...stateOcupaciones,
        descripcion: e.target.value,
        verOcupaciones: true,
        ocupacionesFilter: ocupacionesFilter
      })
      setState((state) => {
        return {
          ...state,
          hijoSeleccionado: {
            ...state.hijoSeleccionado,
            ocupacion: {
              codigo: null,
              descripcion: e.target.value
            }
          }
        }
      })
    } else {
      setStateOcupaciones({
        ...stateOcupaciones,
        descripcion: '',
        verOcupaciones: false,
        ocupacionesFilter: []
      })
      setState((state) => {
        return {
          ...state,
          hijoSeleccionado: {
            ...state.hijoSeleccionado,
            ocupacion: {
              codigo: null,
              descripcion: e.target.value
            }
          }
        }
      })
    }
  }

  const handleOcupacionClick = (ocupacion) => {
    setStateOcupaciones({
      ...stateOcupaciones,
      descripcion: ocupacion.valor,
      ocupacion: ocupacion,
      verOcupaciones: false,
      errorSeleccionandoOcupacion: false
    })

    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          ocupacion: {
            codigo: ocupacion.id,
            descripcion: ocupacion.valor
          }
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          ocupacion: true
        }
      }
    })
    ocupacionesRef.current.value = ocupacion.valor
  }

  const handleChangeText = (e, campo) => {
    let valor = e.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
    let capital = Funciones.mostrarCamelCase(valor)
    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          [campo]: capital
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          [campo]: true
        }
      }
    })
  }

  const handleChangeNumeroDocumento = (e, campo) => {
    //const {hijoSeleccionado} = state
    //const {numeroDocumento, tipoDocumento} = hijoSeleccionado
    let valor = ''

    if (state.hijoSeleccionado !== null && state.hijoSeleccionado.numeroDocumento !== null) {
      switch (state.hijoSeleccionado.tipoDocumento.codigo) {
        case 1:
          valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
          break;
        case 3:
          valor = e.target.value.replace(/[^0-9A-Z]/gi, "")
          valor = valor.toUpperCase()
          break;
        case 4:
          valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
          break;
        default:
          console.error('No existe un Tipo de documento válido')
      }
    }

    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          [campo]: valor
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          [campo]: true
        }
      }
    })
  }

  const handleChangeSexo = (e) => {
    const sexoVal = e.target.value
    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: {
          ...state.hijoSeleccionado,
          sexo: {
            codigo: parseInt(sexoVal),
            descripcion: parseInt(sexoVal) === 1 ? 'Masculino' : parseInt(sexoVal) === 0 ? 'Femenino' : ''
          },
          parentesco: {
            codigo: parseInt(sexoVal) === 1 ? 2 : 3,
            descripcion: parseInt(sexoVal) === 1 ? 'Hijo' : 'Hija'
          }
        },
        campoValidado: {
          ...state.campoValidado,
          sexoH: true
        },
        campoValidadoHijo: {
          ...state.campoValidadoHijo,
          sexo: true
        }
      }
    })
  }

  const handleEnviarHijo = async () => {
    generalDispatch(GeneralActions.updateEstadoCargando(true))
    let hijo = {
      ...state.hijoSeleccionado,
      idSolicitudMultiple: cotizacion.idSolicitudMultiple,
      numeroFamiliar: state.listaFamiliares.length > 0 ? state.listaFamiliares.length + 1 : 1,
      usuario: user.info.IdUsuario
    }
    const response = await FamiliarRepository.guardarFamiliar(hijo)
    if(response.error === null) {
        generalDispatch(GeneralActions.setContratanteCotizacion(response.contratante))
        setState((state) => {
          return {
            ...state,
            estaCargando: false,
            hijoSeleccionado: null
          }
        })
        await recargarLista()
        setModal(false)
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }
  }

  const validarFormulario = () => {
    let validado = true
    const asignarValidacionCampo = (campo, valor) => {
      validado = validado && valor
      setState((state) => {
        return {
          ...state,
          campoValidadoHijo: {
            ...state.campoValidadoHijo,
            [campo]: valor
          }
        }
      })
    }

    const validarTexto = (objeto, campoValidacion, campo) => {
      if (objeto === null || objeto[campo] === undefined ||
        objeto[campo] === '') {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        asignarValidacionCampo(campoValidacion, true)
      }
    }

    const validarCombo = (objeto, campoValidacion, campo) => {
      if (objeto === null || objeto[campo] === null ||
        objeto[campo] === undefined ||
        objeto[campo].codigo === null ||
        objeto[campo].codigo === -1) {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        asignarValidacionCampo(campoValidacion, true)
      }
    }

    const validarFecha = (objeto, campoValidacion, campo) => {
      if (objeto === null || objeto[campo] === undefined ||
        objeto[campo] === '') {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        asignarValidacionCampo(campoValidacion, true)
      }
    }

    const validarNumeroDocumento = (objeto, campoValidacion, campoRelacion, campo) => {
      if (objeto === null
        || objeto[campo] === ''
        || objeto[campo] === undefined) {
        asignarValidacionCampo(campoValidacion, false)
      } else {
        if (objeto != null && objeto[campoRelacion] !== undefined &&
          (objeto[campoRelacion].codigo === 1 || objeto[campoRelacion].codigo === 4)) {
          if (objeto == null
            || objeto[campo] === ''
            || objeto[campo] === undefined
            || objeto[campo].match(/[01]{8,}/)
            || objeto[campo].match(/12345678.*/)) {
            asignarValidacionCampo(campoValidacion, false)
          } else {
            asignarValidacionCampo(campoValidacion, true)
          }
        } else if (objeto != null && objeto[campoRelacion] !== undefined &&
          objeto[campoRelacion].codigo === 3) {
          if (objeto == null
            || objeto[campo] === ''
            || objeto[campo] === undefined
            || objeto[campo].match(/[01]{12}/)) {
            asignarValidacionCampo(campoValidacion, false)
          } else {
            asignarValidacionCampo(campoValidacion, true)
          }
        }
      }
    }

    //Validaciones de los campos del formulario
    validarCombo(state.hijoSeleccionado, 'tipoDocumento', 'tipoDocumento')
    validarNumeroDocumento(state.hijoSeleccionado, 'numeroDocumento', 'tipoDocumento', 'numeroDocumento')
    validarTexto(state.hijoSeleccionado, 'nombres', 'nombres')
    validarTexto(state.hijoSeleccionado, 'apellidoPaterno', 'apellidoPaterno')
    if (state.hijoSeleccionado === null || (state.hijoSeleccionado && state.hijoSeleccionado.tipoDocumento.codigo !== 3)) {
      validarTexto(state.hijoSeleccionado, 'apellidoMaterno', 'apellidoMaterno')
    }
    validarCombo(state.hijoSeleccionado, 'ocupacion', 'ocupacion')
    validarFecha(state.hijoSeleccionado, 'fechaNacimiento', 'fechaNacimiento')
    validarCombo(state.hijoSeleccionado, 'sexo', 'sexo')

    if (validado) {
      return handleEnviarHijo()
    } else {
      return false
    }
  }

  const handleCerrarModal = () => {
    setStateOcupaciones({
      ...stateOcupaciones,
      descripcion: '',
      verOcupaciones: false,
      ocupacionesFilter: []
    })
    setState((state) => {
      return {
        ...state,
        hijoSeleccionado: null,
        campoValidadoHijo: {
          tipoDocumento: true,
          numeroDocumento: true,
          nombres: true,
          apellidoPaterno: true,
          apellidoMaterno: true,
          ocupacion: true,
          fechaNacimiento: true,
          sexo: true
        },
        modalInsertar: false
      }
    })
    setModal(false)
  }

  const tamanioDocumento = (objeto, campoRelacion) => {
    const codeRelation = objeto?.[campoRelacion]?.codigo;
    return codeRelation ? Constantes[`CANTIDAD_DIGITOS_TIPO_DOCUMENTO_${codeRelation}`] : '0';
  }

  let sonSeleccionado = state.hijoSeleccionado !== null ? state.hijoSeleccionado?.idFamiliar : null

  return (
    <React.Fragment>
      <div className={styles['w3-container']}>
        <div className={styles['w3-modal']} style={{ display: mostrarModal ? 'block' : 'none' }}>
          <div className={styles['w3-modal-content']}>
            <div className={styles['w3-header']} />
            <div className={styles['w3-container']}>
              <p className={styles['w3title']}>
                {sonSeleccionado === null || sonSeleccionado === undefined ? 'Agregar Hijo' : 'Editar Hijo'}
              </p>
              <div className={`${styles['grupo-de-form']} ${styles['top-18']} ${styles['w3-margen']}`}>
                <div className={styles['area-50']}>
                  <label>
                    Tipo Doc.&nbsp;
                    {pFamiliar ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}
                  </label>
                  <select
                    className={!state.campoValidadoHijo.tipoDocumento ?
                      `${styles['error-input']}` : styles['']}
                    value={state.hijoSeleccionado !== null &&
                      state.hijoSeleccionado.tipoDocumento !== undefined &&
                      state.hijoSeleccionado.tipoDocumento !== null ?
                      state.hijoSeleccionado.tipoDocumento.codigo : 0}
                    onChange={(e) => handleChangeTipDocumento(e, 'tipoDocumento')}
                  >
                    <option value={-1}>Seleccione</option>
                    {documentos && documentos.filter(doc => doc.id !== 2 && doc.id !== 5).map((documento) => (
                      <option key={documento.id} value={documento.id}>
                        {documento.valor}
                      </option>
                    ))}
                  </select>
                  {!state.campoValidadoHijo.tipoDocumento &&
                    <span className={styles['error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
                  }
                </div>
                <div className={styles['area-50']}>
                  <label>
                    Nro. Doc.&nbsp;
                    {pFamiliar ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}
                  </label>
                  <input
                    className={!state.campoValidadoHijo.numeroDocumento ?
                      `${styles['error-input']}` : styles['']}
                    type='text'
                    value={state.hijoSeleccionado !== null
                      ? state.hijoSeleccionado.numeroDocumento || '' : ''}
                    maxLength={tamanioDocumento(state.hijoSeleccionado, 'tipoDocumento', 'numeroDocumento')}
                    onChange={(e) => handleChangeNumeroDocumento(e, 'numeroDocumento')}
                  />
                  {!state.campoValidadoHijo.numeroDocumento &&
                    <span className={styles['error']}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
                  }
                </div>
              </div>
              <div className={`${styles['grupo-de-form']} ${styles['top-18']} ${styles['w3-margen']}`}>
                <div className={styles['area-100']}>
                  <label>
                    Nombres&nbsp;
                    {Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
                  </label>
                  <input
                    className={!state.campoValidadoHijo.nombres ?
                      `${styles['error-input']}` : styles['']}
                    type='text'
                    value={state.hijoSeleccionado !== null
                      ? state.hijoSeleccionado.nombres || '' : ''}
                    onChange={(e) => handleChangeText(e, 'nombres')}
                    maxLength={40}
                    style={{ paddingLeft: "2.5%" }}
                  />
                  {!state.campoValidadoHijo.nombres &&
                    <span className={styles['error']}>Ingrese los datos solicitados</span>
                  }
                </div>
              </div>
              <div className={`${styles['grupo-de-form']} ${styles['top-18']} ${styles['w3-margen']}`}>
                <div className={styles['area-50']}>
                  <label>
                    Ap. Paterno&nbsp;
                    {Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
                  </label>
                  <input
                    className={!state.campoValidadoHijo.apellidoPaterno ?
                      `${styles['error-input']}` : styles['']}
                    type='text'
                    value={state.hijoSeleccionado !== null
                      ? state.hijoSeleccionado.apellidoPaterno || '' : ''}
                    onChange={(e) => handleChangeText(e, 'apellidoPaterno')}
                    maxLength={30}
                  />
                  {!state.campoValidadoHijo.apellidoPaterno &&
                    <span className={styles['error']}>Ingrese los datos solicitados</span>
                  }
                </div>
                <div className={styles['area-50']}>
                  <label>
                    Ap. Materno&nbsp;
                    {
                      !state.hijoSeleccionado
                        ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS
                        : state.hijoSeleccionado !== null && state.hijoSeleccionado.tipoDocumento &&
                          state.hijoSeleccionado.tipoDocumento.codigo !== 3
                            ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : ''
                    }
                  </label>
                  <input
                    className={!state.campoValidadoHijo.apellidoMaterno ?
                      `${styles['error-input']}` : styles['']}
                    type='text'
                    value={state.hijoSeleccionado !== null
                      ? state.hijoSeleccionado.apellidoMaterno || '' : ''}
                    onChange={(e) => handleChangeText(e, 'apellidoMaterno')}
                    maxLength={30}
                  />
                  {!state.campoValidadoHijo.apellidoMaterno &&
                    <span className={styles['error']}>Ingrese los datos solicitados</span>
                  }
                </div>
              </div>
              <div className={styles['contenedor4']}>
                <div className={styles['flex5']}>
                  <label>
                    Ocupación&nbsp;
                    {Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
                  </label>
                  <input
                    className={!state.campoValidadoHijo.ocupacion ?
                      `${styles['error-input']}` : styles['']}
                    type='text'
                    value={state.hijoSeleccionado !== null && state.hijoSeleccionado.ocupacion
                      ? state.hijoSeleccionado.ocupacion.descripcion : ''}
                    onChange={handleChangeOcupacion}
                    ref={ocupacionesRef}
                  />
                  <div className={styles['autocompletar']}>
                    <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
                      {stateOcupaciones.verOcupaciones
                        ? stateOcupaciones.ocupacionesFilter.map(ocu => (
                          <div key={ocu.id}
                            onClick={event => handleOcupacionClick(ocu)}
                          >
                            {ocu.valor.substring(0, ocu.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()))}
                            <strong>{Funciones.mostrarCamelCase(ocu.valor).substring(ocu.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()),
                              ocu.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length)}
                            </strong>
                            {ocu.valor.substring(
                              ocu.valor.toUpperCase().indexOf(stateOcupaciones.descripcion.toUpperCase()) + stateOcupaciones.descripcion.length,
                              ocu.valor.length
                            )}
                          </div>
                        ))
                        : null}
                    </div>
                  </div>
                  {!state.campoValidadoHijo.ocupacion &&
                    <span className={styles['error']}>{Constantes.MENSAJE_VALIDACION_OCUPACION}</span>
                  }
                </div>
                {/*Se utiliza el componente CampoFecha */}
                <div className={!state.campoValidadoHijo.fechaNacimiento ? styles['flex6'] : styles['flex7']}>
                  <CampoFecha
                    name={'Fecha Nacimiento'}
                    esObligatorio={true}
                    valor={(state.hijoSeleccionado !== null && state.hijoSeleccionado.fechaNacimiento !== null &&
                      state.hijoSeleccionado.fechaNacimiento !== '1901-01-01') ?
                      Funciones.transformarFechaToDatePicker(state.hijoSeleccionado.fechaNacimiento) : ''}
                    disabled={false}
                    onChange={(valor) => onChangeInputDate(valor)}
                    validacion={state.campoValidadoHijo.fechaNacimiento}
                    mensaje={Constantes.MENSAJE_VALIDACION_FEC_NACIMIENTO}
                  />
                </div>
              </div>
              <div className={`${styles['grupo-de-form2']} ${styles['top-18']} ${styles['w3-margen']}`}>
                <div className={styles['area-50']}>
                  <label style={{ marginBottom: '-3%' }}>
                    Sexo&nbsp;
                    {Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}
                  </label>
                  <form>
                    <div className={styles['centered']}>
                      <label className={styles['label-radio']}>
                        <input
                          type='radio'
                          name='sexo'
                          value={0}
                          selected={(state.hijoSeleccionado !== null &&
                            state.hijoSeleccionado.sexo !== null) ?
                            (state.hijoSeleccionado.sexo && state.hijoSeleccionado.sexo.codigo) === 0 : false}
                          checked={(state.hijoSeleccionado !== null &&
                            state.hijoSeleccionado.sexo !== null) ?
                            (state.hijoSeleccionado.sexo && state.hijoSeleccionado.sexo.codigo) === 0 : false}
                          onChange={handleChangeSexo}
                        />
                        <div style={{ lineHeight: '35px', marginLeft: '0.75em' }}>
                          Femenino
                        </div>
                      </label>
                      <label className={styles['label-radio']}>
                        <input
                          type='radio'
                          name='sexo'
                          value={1}
                          selected={(state.hijoSeleccionado !== null &&
                            state.hijoSeleccionado.sexo !== null) ?
                            (state.hijoSeleccionado.sexo && state.hijoSeleccionado.sexo.codigo) === 1 : false}
                          checked={(state.hijoSeleccionado !== null &&
                            state.hijoSeleccionado.sexo !== null) ?
                            (state.hijoSeleccionado.sexo && state.hijoSeleccionado.sexo.codigo) === 1 : false}
                          onChange={handleChangeSexo}
                        />
                        <div style={{ lineHeight: '35px', marginLeft: '0.75em' }}>
                          Masculino
                        </div>
                      </label>
                    </div>
                    {!state.campoValidadoHijo.sexo &&
                      <span className={styles['error']}>{Constantes.MENSAJE_VALIDACION_SEXO}</span>
                    }
                  </form>
                </div>
              </div>
              <div className={styles['w3areabtn']}>
                <button
                  className={styles['btn-pago-accion']}
                  onClick={validarFormulario}
                >
                  {state.hijoSeleccionado === null || state.hijoSeleccionado?.idFamiliar === undefined
                    || state.hijoSeleccionado.idFamiliar === null ? 'Agregar' : 'Actualizar'
                  }
                </button>
                <button
                  className={`${styles['btn-cancelar']} ${styles['w3-margen']}`}
                  onClick={handleCerrarModal}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AgregarHijo
